"use strict";

import {
    scrollDetector,
    toggleMenu,
    toggleSubMenu,
    hoverSubMenu
} from "./modules/menu.js";

import accordion from "./modules/accordion.js";
import videoControls from "./modules/video-controls.js";
import jamlMore from "./modules/jaml-more.js";
import initScrollToTop from "./modules/goup.js";
import calendarModule from "./modules/calendar-module.js";
import lightboxGallery from "./modules/lightbox.js";
import searchModule from "./modules/search-module.js";


document.addEventListener("DOMContentLoaded", () => {
    toggleMenu();
    scrollDetector();
    toggleSubMenu();
    hoverSubMenu();
    videoControls();
    jamlMore();
    initScrollToTop();
    accordion();
    lightboxGallery();


    fetch(scriptObj.ajaxurl + '?action=get_new_nonce')
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                scriptObj.nonce = data.data.nonce;
                console.log(scriptObj);
            }
            calendarModule();
            searchModule();
        })
        .catch(() => {
            calendarModule();
            searchModule();
        });


});